import { colors } from '@mui/material';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  columnContent1: {
    width: '6%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#e0e0e0', '#ffffff'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DoctorLedgerReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const groupByDate = (data) => {
    return data.reduce((groups, item) => {
      const date = formatDate(item?.date); // Format the date to a human-readable format
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(item);
      return groups;
    }, {});
  };

  const groupByService = (data) => {
    return data.reduce((acc, curr) => {
      const serviceName = curr.serviceDetail?.service_name || 'Unknown';
      if (!acc[serviceName]) {
        acc[serviceName] = [];
      }
      acc[serviceName].push(curr);
      return acc;
    }, {});
  };

  // Format the grouped data to render in your PDF
  const groupedData = groupByDate(data?.ipdBillingData?.data);
  const opdGroupData = groupByDate(data?.opdData?.data);
  const opdBillingGroupData = groupByDate(data?.opdBillingData?.data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Doctor Legder Detail Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
              <Text style={{ ...styles.Text, width: '100%',fontSize:"15px" ,textAlign:"center"}} content={data?.opdData?.data[0]?.consultant?.name} />
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '80px' }} content="Sr No" />
              <Text style={{ ...styles.columnHeader, width: '250px' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={{ ...styles.columnHeader, width: '30%' }} content="Address" />
              <Text style={styles.columnHeader} content="Mobile" />
              <Text style={styles.columnHeader} content="Service Type" />
              <Text style={styles.columnHeader} content="Paymode" />
              <Text style={{ ...styles.columnHeader }} content="Panel" />
              <Text style={styles.columnHeader} content="Bill Amt." />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD (Consultancy)" />
            </View>

            {Object.keys(opdGroupData).map((groupDate) => {
              return (
                <>
                  <View key={groupDate} style={{ marginBottom: 20 }}>
                    <Text style={{ ...styles.header, fontSize: '10px' }} content={groupDate} />

                    {/* Group by service name */}
                    {Object.keys(groupByService(opdGroupData[groupDate])).map((serviceName) => (
                      <>
                        <Text style={{ ...styles.header, fontSize: '10px', marginTop: '10px' }} content={"Consultancy"} />
                        {groupByService(opdGroupData[groupDate])[serviceName].map((data, index) => (
                          <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                            <Text style={{ ...styles.columnContent, width: '80px' }} content={index + 1} />
                            <Text
                              style={{ ...styles.columnContent, width: '250px', textAlign: 'left' }}
                              content={`${data.name_suffix} ${data.first_name} ${data.last_name}`}
                            />
                            <Text style={styles.columnContent} content={data.uhid} />
                            <Text style={styles.columnContent} content={data?.patient?.adm_no_date} />
                            <Text   style={{ ...styles.columnContent, width: '30%',textAlign:'start' }} content={data?.address?.address} />
                            <Text style={styles.columnContent} content={data?.address?.mobile} />
                            <Text style={styles.columnContent} content={""} />
                            <Text style={styles.columnContent} content={data.payment_mode} />
                            <Text style={styles.columnContent} content={data.sponsor.name} />
                            <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.reg} />
                          </View>
                        ))}
                      </>
                    ))}
                  </View>
                </>
              );
            })}
            {/* OPD Billing Data Section */}
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD BILLING" />
            </View>

            {Object.keys(opdBillingGroupData).map((groupDate) => {
              return (
                <>
                  <View key={groupDate} style={{ marginBottom: 20 }}>
                    <Text style={{ ...styles.header, fontSize: '10px' }} content={groupDate} />

                    {/* Group by service name */}
                    {Object.keys(groupByService(opdBillingGroupData[groupDate])).map((serviceName) => (
                      <>
                        <Text style={{ ...styles.header, fontSize: '10px', marginTop: '10px' }} content={serviceName} />
                        {groupByService(opdBillingGroupData[groupDate])[serviceName].map((data, index) => (
                          <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                            <Text style={{ ...styles.columnContent, width: '80px' }} content={index + 1} />
                            <Text
                              style={{ ...styles.columnContent, width: '250px', textAlign: 'left' }}
                              content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                            />
                            <Text style={styles.columnContent} content={data.uhid} />
                            <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                            <Text   style={{ ...styles.columnContent, width: '30%',textAlign:'start' }} content={data?.patient?.address?.address} />
                            <Text style={styles.columnContent} content={data?.patient?.address?.mobile} />
                            <Text style={styles.columnContent} content={data?.serviceDetail?.type} />
                            <Text style={styles.columnContent} content={data.pay_mode} />
                            <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                            <Text
                              style={{ ...styles.columnContent, textAlign: 'right' }}
                              content={data.service_items?.amount}
                            />
                          </View>
                        ))}
                      </>
                    ))}
                  </View>
                </>
              );
            })}

            {/* IPD Billing Data Section */}
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="IPD BILLING" />
            </View>

            {Object.keys(groupedData).map((groupDate) => {
              return (
                <>
                  <View key={groupDate} style={{ marginBottom: 20 }}>
                    <Text style={{ ...styles.header, fontSize: '10px' }} content={groupDate} />

                    {/* Group by service name */}
                    {Object.keys(groupByService(groupedData[groupDate])).map((serviceName) => (
                      <>
                        <Text style={{ ...styles.header, fontSize: '10px', marginTop: '10px' }} content={serviceName} />
                        {groupByService(groupedData[groupDate])[serviceName].map((data, index) => (
                          <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                            <Text style={{ ...styles.columnContent, width: '80px' }} content={index + 1} />
                            <Text
                              style={{ ...styles.columnContent, width: '250px', textAlign: 'left' }}
                              content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                            />
                            <Text style={styles.columnContent} content={data?.patient?.uhid} />
                            <Text style={styles.columnContent} content={data.ipd_no} />
                            <Text   style={{ ...styles.columnContent, width: '30%',textAlign:'start' }} content={data?.patient?.address?.address} />
                            <Text style={styles.columnContent} content={data?.patient?.address?.mobile} />
                            <Text style={styles.columnContent} content={data?.serviceDetail?.type} />
                            <Text style={styles.columnContent} content={data.pay_mode} />
                            <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                            <Text
                              style={{ ...styles.columnContent, textAlign: 'right' }}
                              content={data.service_items?.amount}
                            />
                          </View>
                        ))}
                      </>
                    ))}
                  </View>
                </>
              );
            })}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
